// packages block
import { Avatar, Box, IconButton, Menu, MenuItem } from '@mui/material';
import { FC, useContext, useRef, useState } from 'react';
// others block
import { PrimaryDots } from '../../assets/images';
import { AppContext, AuthContext } from '../../context';
import { ActionType } from '../../context/AppContextReducer';
import { CourtsMenuProps } from '../../interfaceTypes';
import { anchorOrigin, menuPaperStyles, transformOrigin } from '../../theme/styleConstants';
import { CourtActionType } from '../courts/CourtReducer';

export const CourtsMenu: FC<CourtsMenuProps> = ({ court, dispatch, state }): JSX.Element => {
  const [open, setOpen] = useState<boolean>(false);
  const { isEdit, dispatch: appDispatch, isDeleteOpen } = useContext(AppContext)
  const { isAdmin } = useContext(AuthContext)
  const { id: courtId } = court || {}

  const handleClick = () => setOpen(!open);

  const handleClose = () => setOpen(false);

  const anchorRef = {
    [courtId!]: useRef<HTMLButtonElement>(null),
  };

  const handleViewModal = () => {
    handleClose();
    appDispatch({ type: ActionType.SET_IS_EDIT, isEdit: !isEdit })
    dispatch({ type: CourtActionType.SET_CURRENT_COURT, currentCourt: court })
  }

  const handleDeleteModal = () => {
    handleClose();
    appDispatch({ type: ActionType.SET_IS_DELETE_OPEN, isDeleteOpen: !isDeleteOpen })
    dispatch({ type: CourtActionType.SET_CURRENT_COURT, currentCourt: court })
  }

  return (
    <Box>
      <IconButton
        ref={anchorRef[courtId!]}
        id={`long-button-${courtId}`}
        aria-controls={`long-menu-${courtId}`}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <Avatar sx={{ bgcolor: 'transparent' }}>
          <PrimaryDots />
        </Avatar>
      </IconButton>

      <Menu
        id={`long-menu-${courtId}`}
        anchorEl={anchorRef[courtId!].current}
        open={open}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
        onClose={handleClose}
        PaperProps={menuPaperStyles}
      >
        <MenuItem onClick={handleViewModal}>View</MenuItem>
        {isAdmin && <MenuItem onClick={handleDeleteModal} color='primary.main'>Delete</MenuItem>}
      </Menu>
    </Box>
  );
};
